import React from 'react';
import { Box, Skeleton } from '@mui/material';

import { DashboardGrid } from './DashboardGrid';

/**
 * DashboardSkeleton Component
 * 
 * Loading skeleton that matches the dashboard layout.
 * Shows 6 card placeholders while data is being fetched.
 */
export const DashboardSkeleton: React.FC = () => {
  return (
    <DashboardGrid>
      {/* Render 6 skeleton cards to fill the grid nicely */}
      {[1, 2, 3, 4, 5, 6].map((index) => (
        <Box
          key={`skeleton-${index}`}
          sx={{
            borderRadius: 2,
            overflow: 'hidden',
            backgroundColor: 'background.paper',
            boxShadow: 1,
          }}
        >
          {/* Card header skeleton */}
          <Box sx={{ p: 2, borderBottom: 1, borderColor: 'divider' }}>
            <Skeleton variant="text"  sx={{ width: "40%", height: 28 }}/>
          </Box>
          
          {/* Card content skeleton */}
          <Box sx={{ p: 3 }}>
            <Skeleton variant="rectangular" sx={{height: 120,  mb: 2 }} />
            <Skeleton variant="text"  sx={{ width: "80%" }}/>
            <Skeleton variant="text"  sx={{ width: "60%" }}/>
          </Box>
          
          {/* Card footer skeleton */}
          <Box sx={{ p: 2, borderTop: 1, borderColor: 'divider' }}>
            <Skeleton variant="rectangular" sx={{width: 100, height: 36,  borderRadius: 1 }} />
          </Box>
        </Box>
      ))}
    </DashboardGrid>
  );
};

export default DashboardSkeleton;